/* eslint-disable */
export default {
  _bpreplaybold: 'bpreplaybold',
}